<svg #svg [style.width]="width" [style.height]="height"></svg>
